import React from "react";

const VendorsIcon = (props) => {
  return (
    <svg
      {...props}
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M8 14L12.41 9.59C12.5961 9.40283 12.8173 9.25434 13.061 9.15308C13.3047 9.05182 13.5661 8.99979 13.83 9H22.17C22.4339 8.99979 22.6953 9.05182 22.939 9.15308C23.1827 9.25434 23.4039 9.40283 23.59 9.59L28 14"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill="none"
        d="M10 19V27C10 27.5304 10.2107 28.0391 10.5858 28.4142C10.9609 28.7893 11.4696 29 12 29H24C24.5304 29 25.0391 28.7893 25.4142 28.4142C25.7893 28.0391 26 27.5304 26 27V19"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill="none"
        d="M21 29V25C21 24.4696 20.7893 23.9609 20.4142 23.5858C20.0391 23.2107 19.5304 23 19 23H17C16.4696 23 15.9609 23.2107 15.5858 23.5858C15.2107 23.9609 15 24.4696 15 25V29"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 14H28"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill="none"
        d="M28 14V17C28 17.5304 27.7893 18.0391 27.4142 18.4142C27.0391 18.7893 26.5304 19 26 19C25.4157 18.9678 24.8577 18.7467 24.41 18.37C24.2907 18.2838 24.1472 18.2374 24 18.2374C23.8528 18.2374 23.7093 18.2838 23.59 18.37C23.1423 18.7467 22.5843 18.9678 22 19C21.4157 18.9678 20.8577 18.7467 20.41 18.37C20.2907 18.2838 20.1472 18.2374 20 18.2374C19.8528 18.2374 19.7093 18.2838 19.59 18.37C19.1423 18.7467 18.5843 18.9678 18 19C17.4157 18.9678 16.8577 18.7467 16.41 18.37C16.2907 18.2838 16.1472 18.2374 16 18.2374C15.8528 18.2374 15.7093 18.2838 15.59 18.37C15.1423 18.7467 14.5843 18.9678 14 19C13.4157 18.9678 12.8577 18.7467 12.41 18.37C12.2907 18.2838 12.1472 18.2374 12 18.2374C11.8528 18.2374 11.7093 18.2838 11.59 18.37C11.1423 18.7467 10.5843 18.9678 10 19C9.46957 19 8.96086 18.7893 8.58579 18.4142C8.21071 18.0391 8 17.5304 8 17V14"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default VendorsIcon;
